// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_gX","advertCardPhoto__image":"c-a_gY"};